import getRadianAngle from './get-radian-angle'

interface RotateSizeParams {
  width: number
  height: number
  rotation: number
}

const rotateSize = ({ width, height, rotation }: RotateSizeParams) => {
  const rotRad = getRadianAngle(rotation)

  return {
    width: Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
    height: Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
  }
}

export default rotateSize
